import Lottie from 'lottie-react';
import animation from '../../../static/lottie/folder-animation.json';

const lottieIconStyles = {
  width: '280px',
  height: '280px',
};

const AnimatedFolder = () => {
  return <Lottie loop style={lottieIconStyles} animationData={animation} />;
};

export default AnimatedFolder;
